<template>
    <vs-row>
        <!-- pop up -->
        <vs-popup class="holamundo" title="Effective Dates" :active.sync="popupActivo">
            <vs-col vs-lg="12">
                <table class="dateTable" style="width:-webkit-fill-available">
                    <thead>
                        <th style="width:3%">SlNo</th>
                        <th style="width:5%">Effective Date</th>
                    </thead>
                    <tbody>
                        <tr v-for="(dates,index) in dateList" v-bind:key="index" @dblclick="getRoomRates(dates.effectiveDate)">
                            <td style="border:1px solid #eaeff3;text-align:center">{{index+1}}
                                <!-- <vs-input  class="configclass"></vs-input> -->
                            </td>
                            <td>
                                <vs-input readonly v-model="dates.effectiveDate" class="configclass" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style="margin-top:2%">
                    <vs-pagination :total="totalRecord" v-model="currentx" @change="searchEffectiveDates"></vs-pagination>
                </div>
            </vs-col>
        </vs-popup>
        <!-- pop up -->
        <vx-card style="min-height:500px">
            <vs-row>
                <vs-alert color="danger" icon-pack="feather" icon="icon-info" v-for="(errors,err) in errorMessage" v-bind:key="err">
                    <span>{{errors}}</span>
                </vs-alert>
            </vs-row>

            <div class="vx-row " style="margin-top:20px;margin-left:29px">
                <div class="vx-col sm:w-1/6 w-full">
                    <span style="margin-top: 8px;">
                        <p style="font-size:13.2px;font-weight:600;padding-top:6px;">Effective Date</p>
                    </span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                    <!-- <flat-pickr v-model="effectiveDate" placeholder="To Date"  /> -->
                    <vs-input readonly class="w-full" v-model="effectiveDate" />
                </div>
                <div class="vx-col" style="padding-left: 6px;padding-top: 6px;">
                    <feather-icon icon="SearchIcon" class="mr-0 cursor-pointer" @click="openForm"></feather-icon>
                </div>
                <div class="vx-col w-1/4">
                    <div :class="{'activeLoading':activeLoading}" :id="[`loading-material`]" class="vs-con-loading__container loading-example">
                    </div>
                </div>
            </div>

            <div class="vx-row w-full" style="padding-left: 4%;padding-right: 5%;margin-top:3%;">
                <vs-col vs-lg="12">
                    <table style="width:-webkit-fill-available">
                        <thead>
                            <!-- <th style="width:9%">SiNo</th> -->
                            <th style="width:30%">Category Name</th>
                            <th style="width:10%">Room Rate</th>
                            <th style="width:3%">&nbsp;</th>
                        </thead>
                        <tbody>
                        <tr v-for="(config,index) in configList" v-bind:key="index">
                            <!-- <td>
                                <vs-input class="configclass"></vs-input>
                            </td> -->
                        <td>
                            <select :disabled="readonlyFlag" v-model="config.categoryId" class=" vs-select--input myselect" style="height: 36px;" @change="getLastUpdatedDate(config.categoryId,index)" >
                                <option v-for="(item,index) in categoryList" v-bind:key="index" :value="item.id" >{{item.name}}</option>
                            </select>
                        </td>
                        <td>
                            <vs-input :readonly="readonlyFlag" v-model="config.rate" class="configclass" @keydown.tab="insertRow(index)" />
                        </td>
                        <td>
                            <feather-icon :readonly="readonlyFlag" icon="Trash2Icon" class="mr-0 cursor-pointer" @click="openConfirm(index)"></feather-icon>
                        </td>
                    </tr>
                </tbody>
            </table>
            </vs-col>
            </div>
            <vs-row style="display: block;">
                <vs-button :disabled="saveFlag" style="margin-top: 8px;margin-bottom:8px;float: right;margin-right:8%;" id="button-with-loading" class="float-center vs-con-loading__container" @click="validateForm" color="success" type="filled">Save</vs-button>
            </vs-row>
        </vx-card>
    </vs-row>
</template>
<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
    data(){
        return{
            popupActivo: false,
            activeLoading: false,
            errorMessage: [],
            saveFlag:false,
            deleteRowIndex: "",
            lastUpdateDate:"",
            readonlyFlag:false,
            totalRecord:'',limit:4,currentx:1,
            effectiveDate: new Date().toISOString().slice(0, 10),
            configList: [{
                "categoryId": "",
                "rate": "",
            }],
            categoryList: [{
                  "id": 0,
                "name": "Select"}
            ],
            dateList:[],
            slNo:1,
        }
    },
    components: {
        flatPickr
    },
    beforeMount() {
        // this.readonlyFlag=false;
        this.getRoomCategory();
    },
    methods:{
        openForm() {
            this.searchEffectiveDates();
            this.popupActivo = true;
        },
        searchEffectiveDates(){
            var request = {
                companyId: this.$session.get('companyId'),
                currentPage: this.currentx,
                limit: this.limit
            };
            this.$http.post(
                    "/searchEffectiveDate",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                //     response.data.data.forEach((value) => {
                //      this.dateList.push(value);
                // })
                this.dateList=response.data.data;
                 this.totalRecord = Math.ceil(response.data.recordsTotal / this.limit);
                // this.readonlyFlag=true;
            });
        },
        getRoomCategory(){
            // this.readonlyFlag=false;
            var request = {
                companyId: this.$session.get('companyId')
            };
            this.$http.post(
                    "/getRoomCategory",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    response.data.data.forEach((value) => {
                     this.categoryList.push(value);
                })
            });
        },

        insertRow(index) {
            if (this.configList.length == (index + 1)) {
                var newrow = {
                    "categoryId": "",
                    "rate": "",
                }
                this.configList.push(newrow)
            }
        },
        openConfirm(index) {
            this.deleteRowIndex = index;
            if (this.configList.length != 1) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirm`,
                    text: 'Are you sure to Delete',
                    accept: this.acceptAlert
                });
            } else {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Invalid',
                    text: 'First Row Cannot Delete'
                })
            }

        },
        acceptAlert() {
            this.$delete(this.configList, this.deleteRowIndex);
            this.$vs.notify({
                color: 'danger',
                title: 'Deleted',
                text: 'The Row was successfully deleted'
            })
        },
        deleteRow() {
            if (this.$delete(this.configList, this.deleteRowIndex)) {
                this.acceptAlert;
            }
        },
        openLoading() {
            this.activeLoading = true
            this.$vs.loading();
        },
        getRoomRates(dates){
            this.openLoading();
            this.errorMessage = [];
            this.popupActivo=false;
            this.saveFlag=true;
            // this.readonlyFlag=false;
            var request = {
                companyId: this.$session.get('companyId'),
                effectiveDate:dates
            };
            console.log(JSON.stringify(request));
            this.$http.post(
                    "/getRoomRates",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                this.configList=response.data.data;
                this.$vs.loading.close();
            });
        },
        buttonLoading() {
            document.getElementById('button-with-loading').disabled=true;
            this.$vs.loading({
                background: 'success',
                color: '#fff',
                container: "#button-with-loading",
                scale: 0.45
            })
        },
        getLastUpdatedDate(cId,index){
            var request = {
                companyId: this.$session.get('companyId'),
                categoryId:cId
            };
            console.log( JSON.stringify(request));
            this.$http.post(
                    "/getLastUpdatedDate",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                .then(response => {
                    console.log(response.data.data);
                this.lastUpdateDate=response.data.data;
            });
        },
        validateForm(){
            this.errorMessage=[];
            this.configList.forEach((value, key) => {
                if(!value.categoryId){
                    this.errorMessage.push("Category Name is Required");
                }
                if(!value.rate){
                    this.errorMessage.push("Rate Field is Required");
                }
            });
            if (this.errorMessage.length == 0) {
                // alert(this.lastUpdateDate);
                var D1 =new Date(this.effectiveDate);
                var D2 = new Date(this.lastUpdateDate)
                if(D1.getTime() === D2.getTime()){
                    // alert('Already Rate updated');
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Updated',
                        text: 'Can not Update Rate Today.Please Try Tomorrow'
                    })
                }else{
                     this.saveRoomRates();
                }
            }
        },
        saveRoomRates(){
            this.buttonLoading();
            var request = {
                companyId: this.$session.get('companyId'),
                effectiveDate: this.effectiveDate,
                data: this.configList
            };
            console.log( JSON.stringify(request));

            this.$http.post(
                    "saveRoomRates",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })

                .then(response => {
                    // this.readonlyFlag = true;
                    this.$vs.loading.close("#button-with-loading > .con-vs-loading");
                    document.getElementById('button-with-loading').disabled=false;
                    this.$vs.notify({
                        title: 'Saved Successfully',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    });

                }).catch(error => {
                    this.$vs.notify({
                        title: ' Error',
                        text: "Error Occured Plz Try later",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        position: 'top-center'
                    });
                })
        }
    } 
}
</script>
<style>
.configclass {
    width: -webkit-fill-available;
}

table {
    border-collapse: collapse;
}

table th {
    text-align: center;
    line-height: 2.5rem;
}

table thead {
    background: #eaeff3;
}
.myselect:focus{
        border: 1px solid blue;
}
.cHeight {
    min-height: 550px;
}
.dateTable tr {
    cursor: pointer;
}
</style>